import NavBar from 'antd-mobile/lib/nav-bar';
export default NavBar;



// WEBPACK FOOTER //
// ./components/nav-bar/index.tsx